export default [{
  path: '/pages/home',
  name: 'Home',
  component: () => import('@/views/admin/pages/home/Index.vue'),
  meta: {
    rule: 'editor',
    pageTitle: 'Home',
    breadcrumb: [{
      title: 'Home',
      url: '/'
    },
      {
        title: 'Pages'
      },
      {
        title: 'Home',
        active: true
      },
    ],
  },
},
{
  path: '/pages/category',
  name: 'Home',
  component: () => import('@/views/admin/pages/category/Index.vue'),
  meta: {
    rule: 'editor',
    pageTitle: 'Category',
    breadcrumb: [{
      title: 'Home',
      url: '/'
    },
      {
        title: 'Pages'
      },
      {
        title: 'Category',
        active: true
      },
    ],
  },
},
{
  path: '/pages/post',
  name: 'Home',
  component: () => import('@/views/admin/pages/post/Index.vue'),
  meta: {
    rule: 'editor',
    pageTitle: 'Post',
    breadcrumb: [{
      title: 'Home',
      url: '/'
    },
      {
        title: 'Pages'
      },
      {
        title: 'Post',
        active: true
      },
    ],
  },
},
{
  path: '/pages/search',
  name: 'Home',
  component: () => import('@/views/admin/pages/search/Index.vue'),
  meta: {
    rule: 'editor',
    pageTitle: 'Search',
    breadcrumb: [{
      title: 'Home',
      url: '/'
    },
      {
        title: 'Pages'
      },
      {
        title: 'Search',
        active: true
      },
    ],
  },
},
{
  path: '/pages/about-us',
  name: 'Home',
  component: () => import('@/views/admin/pages/about-us/Index.vue'),
  meta: {
    rule: 'editor',
    pageTitle: 'About Us',
    breadcrumb: [{
      title: 'Home',
      url: '/'
    },
      {
        title: 'Pages'
      },
      {
        title: 'About Us',
        active: true
      },
    ],
  },
},
{
  path: '/profile',
  name: 'page-profile',
  component: () => import('@/views/auth/Profile.vue'),
  meta: {
    rule: 'editor',
    pageTitle: 'Home',
    breadcrumb: [{
      title: 'Home',
      url: '/'
    },
      {
        title: 'User'
      },
      {
        title: 'Profile',
        active: true
      },
    ],
  },
},
]
